import React from 'react'
import {Icon} from '@chakra-ui/react'

const MarkerIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.0299 22.51C11.2028 22.649 11.3288 22.7466 11.4 22.8L12 23.25L12.6 22.8C12.6712 22.7466 12.7972 22.649 12.9701 22.51C13.2542 22.2817 13.5695 22.0179 13.9085 21.7213C14.8756 20.8751 15.8425 19.9324 16.7474 18.9144C19.3951 15.9357 21 12.9265 21 10C21 4.76069 16.8974 1 12 1C7.10257 1 3 4.76069 3 10C3 12.9265 4.60488 15.9357 7.25259 18.9144C8.15753 19.9324 9.12439 20.8751 10.0915 21.7213C10.4305 22.0179 10.7458 22.2817 11.0299 22.51ZM15.2526 17.5856C14.4075 18.5363 13.4994 19.4218 12.5915 20.2162C12.3836 20.3981 12.1857 20.5664 12 20.7202C11.8143 20.5664 11.6164 20.3981 11.4085 20.2162C10.5006 19.4218 9.59247 18.5363 8.74741 17.5856C6.39512 14.9393 5 12.3235 5 10C5 5.90598 8.17016 3 12 3C15.8298 3 19 5.90598 19 10C19 12.3235 17.6049 14.9393 15.2526 17.5856ZM8 10C8 7.79072 9.79072 6 12 6C14.2093 6 16 7.79072 16 10C16 12.2093 14.2093 14 12 14C9.79072 14 8 12.2093 8 10ZM12 8C13.1047 8 14 8.89528 14 10C14 11.1047 13.1047 12 12 12C10.8953 12 10 11.1047 10 10C10 8.89528 10.8953 8 12 8Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default MarkerIcon
